<template>
	<div class="pdd">
		<div class="btnbox">
			<el-button type="primary" size="small" @click="onadd()">添加店铺</el-button>
		</div>
		
		<div class="tablebox">
			<div class="filterdiv filterty" ref="filter">
				<el-form :inline="true" :model="formfilter" class="demo-form-inline" size="small" label-width="0"
					v-if="filtershow">
					<el-form-item label="">
						<el-select v-model="formfilter.state" placeholder="状态">
							<el-option label="状态" value=""></el-option>
							<el-option label="启用" :value="1"></el-option>
							<el-option label="禁用" :value="2"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="">
						<el-input v-model="formfilter.shop_name" placeholder="店铺名称"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onfilter">查询</el-button>
						<el-button @click="onreset">重置</el-button>
					</el-form-item>
				</el-form>
			</div>
			
			<div class="zk" @click="filtershow=!filtershow ">
				<span>{{filtershow ? '收起':'展开'}}</span>
			</div>
			
			<div class="tablediv" ref="tablediv">
				<el-table :data="list" style="width: 100%" border height="100%">
					<el-table-column prop="shop_name" label="店铺名称" fixed="left" align="center" header-align="center" min-width="140px">
					</el-table-column>
					<el-table-column label="渠道退货规则" align="center" header-align="center" min-width="110px">
						<template slot-scope="scope">
							<div v-for="(v,k) in appdata.list.pdd_return_rule" :key="k" v-if="scope.row.return_rule == v.id">{{v.name}}</div>
						</template>
					</el-table-column>
					<el-table-column label="撕防伪规则" align="center" header-align="center" min-width="100px">
						<template slot-scope="scope">
							<div v-for="(v,k) in appdata.list.pdd_security_rule" :key="k" v-if="scope.row.security_rule == v.id">{{v.name}}</div>
						</template>
					</el-table-column>
					<el-table-column label="发货时间规则" align="center" header-align="center" min-width="110px">
						<template slot-scope="scope">
							<div v-for="(v,k) in appdata.list.pdd_send_time_rule" :key="k" v-if="scope.row.send_time_rule == v.id">{{v.name}}</div>
						</template>
					</el-table-column>
					<el-table-column prop="profit" label="利润比例" align="center" header-align="center" min-width="80px">
					</el-table-column>
					<el-table-column prop="allocation_rate" label="配货率" align="center" header-align="center" min-width="70px">
					</el-table-column>
					<el-table-column prop="on_time_rate" label="准时率" align="center" header-align="center" min-width="70px">
					</el-table-column>
					<el-table-column prop="delivery_price" label="运费" align="center" header-align="center" min-width="70px">
					</el-table-column>
					<el-table-column prop="show_max_num" label="显示最大数量" align="center" header-align="center" width="110px">
					</el-table-column>
					<el-table-column label="状态" align="center" header-align="center" width="90px">
						<template slot-scope="scope">
							<el-switch v-model="scope.row.state" :active-value="1" :inactive-value="2" @change="onswitch(scope.row)"></el-switch>
						</template>
					</el-table-column>
					<el-table-column label="授权过期时间" align="center" header-align="center" width="110px">
						<template slot-scope="scope">
							<div>{{scope.row.expire_time_str}}</div>
							<div class="a" @click="onadd()">重新授权</div>
						</template>
					</el-table-column>
					<el-table-column label="操作" align="center" header-align="center" fixed="right" width="90px">
						<template slot-scope="scope">
							<div class="operation_i">
								<span @click="onsave(scope.row)">店铺配置</span>
							</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		
		<div class="pagediv">
			<el-pagination background layout="prev, pager, next, sizes, total" :page-sizes="[20, 30, 50, 100, 200]"
				:current-page.sync="page" :page-size="pageSize" :total="total" v-if="total > 0"
				@current-change="handleCurrentChange" @size-change="handleSizeChange">
			</el-pagination>
		</div>
		
		<el-dialog title="店铺配置" :visible.sync="show" width="650px" :before-close="onclose">
			<div class="forms" v-if="show">
				<el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="130px">
					<el-form-item label="渠道退货规则" prop="return_rule" class="item">
						<el-select v-model="ruleForm.return_rule" placeholder="请选择渠道退货规则">
							<el-option :label="v.name" :value="v.id" v-for="(v,k) in appdata.list.pdd_return_rule" :key="k">
							</el-option>
						</el-select>
					</el-form-item>
					
					<el-form-item label="撕防伪规则" prop="security_rule" class="item">
						<el-select v-model="ruleForm.security_rule" placeholder="请选择撕防伪规则">
							<el-option :label="v.name" :value="v.id" v-for="(v,k) in appdata.list.pdd_security_rule" :key="k">
							</el-option>
						</el-select>
					</el-form-item>
					
					<el-form-item label="发货时间规则" prop="send_time_rule" class="item">
						<el-select v-model="ruleForm.send_time_rule" placeholder="请选择发货时间规则">
							<el-option :label="v.name" :value="v.id" v-for="(v,k) in appdata.list.pdd_send_time_rule" :key="k">
							</el-option>
						</el-select>
					</el-form-item>
					
					<el-form-item label="利润比例" prop="profit" class="item">
						<el-input-number v-model="ruleForm.profit" :controls="false" :max="100">
						</el-input-number>
					</el-form-item>
					
					<el-form-item label="配货率" prop="allocation_rate" class="item">
						<el-input-number v-model="ruleForm.allocation_rate" :controls="false" :max="100">
						</el-input-number>
					</el-form-item>
					
					<el-form-item label="准时率" prop="on_time_rate" class="item">
						<el-input-number v-model="ruleForm.on_time_rate" :controls="false" :max="100">
						</el-input-number>
					</el-form-item>
					
					<el-form-item label="运费" prop="delivery_price" class="item">
						<el-input-number v-model="ruleForm.delivery_price" :precision="2" :controls="false">
						</el-input-number>
					</el-form-item>
					
					<el-form-item label="显示最大数量" prop="show_max_num" class="item">
						<el-input-number v-model="ruleForm.show_max_num" :controls="false">
						</el-input-number>
					</el-form-item>
					
					<el-form-item label="状态" prop="state" class="item">
						<el-switch v-model="ruleForm.state" :active-value="1" :inactive-value="2"></el-switch>
					</el-form-item>
				</el-form>
			</div>
			
			<div slot="footer" class="dialog-footer">
				<el-button @click="onclose">取消</el-button>
				<el-button type="primary" @click="onsub()">确定</el-button>
			</div>
			
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: 'pddshop',
		data() {
			return {
				list: [],
				page: 1,
				pageSize: 20,
				total: 0,
				filtershow: true,
				show: false,
				checkobj: {},
				formfilter: {
					state: "",
					shop_name: ""
				},
				ruleForm: {
					id: "",
					state: "",
					return_rule: "",
					security_rule: "",
					send_time_rule: "",
					profit: "",
					allocation_rate: "",
					on_time_rate: "",
					delivery_price: "",
					show_max_num: "",
				},
				rules: {
					return_rule: [{
						required: true,
						message: '请选择渠道退货规则',
						trigger: 'change'
					}],
					
					security_rule: [{
						required: true,
						message: '请选择撕防伪规则',
						trigger: 'change'
					}],
					
					send_time_rule: [{
						required: true,
						message: '请选择发货时间规则',
						trigger: 'change'
					}],
					
					profit: [{
						required: true,
						message: '请输入利润比例',
						trigger: 'blur'
					}],
					
					allocation_rate: [{
						required: true,
						message: '请输入配货率',
						trigger: 'blur'
					}],
					
					on_time_rate: [{
						required: true,
						message: '请输入准时率',
						trigger: 'blur'
					}],
					
					delivery_price: [{
						required: true,
						message: '请输入运费',
						trigger: 'blur'
					}],
					
					show_max_num: [{
						required: true,
						message: '请输入显示最大数量',
						trigger: 'blur'
					}],
				}
			}
		},
		
		inject: ['appdata'],
		
		mounted() {
			this.onlist();
			this.resizeObserver = new ResizeObserver(entries => {
				for (let entry of entries) {
					const cr = entry.contentRect;
					var num = Number(cr.height) + 30;
					this.$refs.tablediv.style.height = "calc(100% - " + num + "px)";
				}
			});
			this.resizeObserver.observe(this.$refs.filter);
		},
		
		beforeDestroy() {
			if (this.resizeObserver) {
				this.resizeObserver.disconnect();
			}
		},
		
		methods: {
			onfilter() {
				this.page = 1;
				this.onlist();
			},
			
			onreset() {
				this.formfilter = {
					state: "",
					shop_name: ""
				};
				this.page = 1;
				this.onlist();
			},
			
			handleCurrentChange() {
				this.onlist();
			},
					
			handleSizeChange(val) {
				this.page = 1;
				this.pageSize = val;
				this.onlist();
			},
			onadd() {
				this.$axios.get('api/user/pdd_auth_url').then(res => {
					if (res.data.code == 0) {
						window.open(res.data.data.url, '_blank');
						// this.onlist();
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},
			
			onlist() {
				var obj = {};
				obj.state = this.formfilter.state;
				obj.shop_name = this.formfilter.shop_name;
				obj.page = this.page;
				obj.limit = this.pageSize;
					
				this.$axios.post('api/user/pdd_shop_list', obj).then(res => {
					if (res.data.code == 0) {
						this.total = res.data.data.count;
						this.list = res.data.data.list;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},
			
			onsave(obj) {
				const url = this.$router.resolve({
					name: "StoreConfig"
				});
				window.open(url.href, "_blank");
				// this.checkobj = obj;
				// this.show = true;
				// for (let key in this.ruleForm) {
				// 	this.ruleForm[key] = obj[key];
				// }
			},
			
			onclose() {
				this.checkobj = {};
				this.show = false;
				this.ruleForm = {
					id: "",
					state: "",
					return_rule: "",
					security_rule: "",
					send_time_rule: "",
					profit: "",
					allocation_rate: "",
					on_time_rate: "",
					delivery_price: "",
					show_max_num: "",
				};
			},
			
			onsub() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						var obj = JSON.parse(JSON.stringify(this.ruleForm));
						// obj.id = this.checkobj.id;
						// console.log(obj);
						// return;
						this.$axios.post('api/user/pdd_shop_save', obj).then(res => {
							if (res.data.code == 0) {
								this.$message.success('操作成功');
								this.onclose();
								this.onlist();
							} else {
								this.$message.error(res.data.message);
							}
						}).catch(err => {
							console.log(err)
						})
					}
				})
			},
			
			onswitch(data) {
				// for (let key in this.ruleForm) {
				// 	this.ruleForm[key] = data[key];
				// }
				
				// var obj = JSON.parse(JSON.stringify(this.ruleForm));
				
				var obj = {
					id: data.id,
					state: data.state,
				};
				
				this.$axios.post('api/user/pdd_shop_save', obj).then(res => {
					if (res.data.code == 0) {
						this.$message.success('操作成功');
						this.onclose();
						this.onlist();
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.pdd {
		height: 100%;
	}
	
	.tablebox {
		height: calc(100% - 104px);
	}
	
	/deep/ .el-input-number .el-input__inner {
		text-align: left;
	}
	
	/deep/ .item .el-select {
		width: 300px;
	}
	
	/deep/ .item .el-input-number {
		width: 300px;
	}
	
	/deep/ .item .el-textarea {
		width: 300px;
	}
	
	.a {
		cursor: pointer;
		color: #ff4714;
	}
</style>


// WEBPACK FOOTER //
// src/components/pdd/shop.vue